import { CourseDetail, CourseListItem } from '../types/content';

let publicList: CourseListItem[] | null = null;
let publicListPromise: Promise<CourseListItem[]> | null = null;
const publicDetails = new Map<string, CourseDetail>();

export function invalidatePublicCourseCache() {
  publicList = null;
  publicListPromise = null;
  publicDetails.clear();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('idcoder-catalog-changed'));
  }
}

export function getCachedPublicCourseList() {
  return publicList;
}

export function setCachedPublicCourseList(courses: CourseListItem[]) {
  publicList = courses;
}

export function rememberPublicCourseList(loader: () => Promise<CourseListItem[]>) {
  if (publicList) return Promise.resolve(publicList);
  if (!publicListPromise) {
    publicListPromise = loader()
      .then((courses) => {
        publicList = courses;
        return courses;
      })
      .catch((error) => {
        publicListPromise = null;
        throw error;
      });
  }
  return publicListPromise;
}

export function getCachedCourseDetail(slug: string) {
  return publicDetails.get(slug.toLowerCase()) || null;
}

export function setCachedCourseDetail(slug: string, course: CourseDetail) {
  publicDetails.set(slug.toLowerCase(), course);
}

export function filterPublicCourses(
  courses: CourseListItem[],
  opts: {
    search?: string;
    categoryId?: string | number;
    difficulty?: string;
    sort?: string;
    featuredOnly?: boolean;
    minRating?: string | number;
  }
) {
  const term = (opts.search || '').trim().toLowerCase();
  const search = term.length >= 3 ? term : '';
  const categoryId = opts.categoryId ? String(opts.categoryId) : '';
  const difficulty = (opts.difficulty || '').trim();

  let rows = courses.filter((course) => {
    const minRating = Number(opts.minRating || 0);
    if (minRating >= 1 && Number(course.averageRating || 0) < minRating) return false;
    if (opts.featuredOnly && !course.isFeatured) return false;
    if (categoryId && String(course.categoryId || '') !== categoryId) return false;
    if (difficulty && course.difficulty.toLowerCase() !== difficulty.toLowerCase()) return false;
    if (!search) return true;
    return [course.title, course.subtitle, course.summary, course.categoryName]
      .some((value) => (value || '').toLowerCase().includes(search));
  });

  if (opts.sort === 'featured' || opts.featuredOnly) {
    rows = [...rows].sort((a, b) => Number(b.isFeatured) - Number(a.isFeatured));
  } else {
    rows = [...rows].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0) || a.title.localeCompare(b.title));
  }

  return rows;
}
